import { Component, Input, OnInit } from '@angular/core';
import { SelfEmployedModel } from './selfemployed.model';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { Observable } from "rxjs";
import { FormControl } from '@angular/forms';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { BankAccountService } from '../../finanzas/bancos/bankaccount.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Utils } from '../../../shared/utils';
import { consts } from '../../../consts';
import { PaymentCardModel } from '../../finanzas/paymentcard/paymentcard.model';
import { PaymentCardService } from '../../finanzas/paymentcard/paymentcard.service';
import { EfectivoService } from '../../../services/finanzas/efectivo/efectivo.service';
import { Efectivo } from '../../../models/finanzas/efectivo/efectivo.model';
import { PartnersModel } from '../../user/partnersequity/partners/partners.model';
import { PartnersService } from '../../user/partnersequity/partners/partners.service';
import { PolizaCredito } from '../../../models/finanzas/poliza-credito/poliza-credito.model';
import { PolizaCreditoService } from '../../../services/finanzas/poliza-credito/poliza-credito.service';
import { Option } from '../../../shared/models/option.model';

@Component({
    selector: 'convfact-selfEmployed-form',
    templateUrl: './selfemployed-form.component.html',
    styleUrls: ['./selfemployed.component.css'],
    standalone: false
})

export class SelfEmployedFormComponent implements OnInit {
  @Input() selfEmployed: SelfEmployedModel;
  @Output() onSave = new EventEmitter<any>();
  @Input() errors: object;

  public saved: boolean = false;

  constructor(
    public snackBar: MatSnackBar,
    private paymentCardService: PaymentCardService,
    private bankAccountService: BankAccountService,
    private efectivoService: EfectivoService,
    private partnersService: PartnersService,
    private polizaCreditoService: PolizaCreditoService,
  ) { }

  showQR: boolean = false;

  filteredPayMethod: Observable<any>;
  bankAccounts: BankAccountModel[] = [];
  paymentCards: PaymentCardModel[] = [];

  payMethods: string[] = [
    consts.TYPEPAY_CASH,
    consts.TYPEPAY_CREDITCARD_PAY,
    consts.TYPE_DEBITCARD,
    consts.TYPEPAY_DEBITENTRY,
    consts.TYPEPAY_BANKTRANSFERENCE,
    consts.TYPEPAY_CONFIRMING,
    consts.TYPEPAY_PAGARES,
    consts.TYPE_SOCIO,
    consts.TYPE_POLIZACREDITO,
  ];

  ready: boolean = false;

  public efectivoList: Efectivo[] = [];

  public sociosList: PartnersModel[] = [];

  public polizaCreditoList: PolizaCredito[] = [];

  public get payMethodsOptions(): Option[] {
    return this.payMethods.map(method => ({ label: method, value: method }));
  }

  ngOnInit() {
    this.ready = false;

    this.polizaCreditoService.listPayments()
      .then(polizaCredito => {
        this.polizaCreditoList = polizaCredito
      });

    this.partnersService.list()
      .then(response => {
        this.sociosList = response
      });

    this.bankAccountService.getList().then(
      bankAccounts => {
        this.bankAccounts = bankAccounts.list;

        this.paymentCardService.getList(0).then(
          paymentCards => {
            this.paymentCards = paymentCards.list;

            this.efectivoService.list()
              .then(listadoEfectivos => {
                this.efectivoList = listadoEfectivos
                this.ready = true;
              })

          });
      }
    );
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  save(selfEmployed) {
    let noError = true;

    if (!Utils.DateIsInFiscalYear(selfEmployed.date)) {
      noError = false;
      this.displayInfo("La fecha y el año fiscal seleccionado, no son el mismo.");
    }

    if (selfEmployed.paided == null) {
      noError = false;
      this.displayInfo("Debe especificar la fecha del pago.");
    } else {
      if (selfEmployed.typePay == null || selfEmployed.typePay == "") {
        noError = false;
        this.displayInfo("El tipo de pago debe estar especificado.");
      } else {
        if ((selfEmployed.typePay == "Transferencia bancaria" || selfEmployed.typePay === "Cargo en cuenta"
          || selfEmployed.typePay === consts.TYPEPAY_CONFIRMING || selfEmployed.typePay === consts.TYPEPAY_PAGARES) &&
          (selfEmployed.typePayBankAccount == null || selfEmployed.typePayBankAccount == "")) {
          noError = false;
          this.displayInfo("Debe especificar la cuenta bancaria.");
        }
        if (selfEmployed.typePay == "Tarjeta de crédito" && (selfEmployed.typePayBankAccount == null || selfEmployed.typePayBankAccount == "")) {
          noError = false;
          this.displayInfo("Debe especificar la tarjeta de crédito.");
        }
      }

    }

    if (selfEmployed.typePay !== consts.TYPEPAY_CASH) {
      selfEmployed.efectivoId = null;
    }

    if (selfEmployed.typePay !== consts.TYPE_SOCIO) {
      selfEmployed.partnersId = 0;
    }

    if (selfEmployed.recargo == null) {
      selfEmployed.recargo = 0;
    }

    if (selfEmployed.typePay !== consts.TYPE_POLIZACREDITO) {
      selfEmployed.polizaCreditoId = null;
    }

    if (noError) {
      this.onSave.emit(selfEmployed)
    }
  }

  changeToggle(element) {
  }

  public selectionChangeTypePay(value: string): void {

    if (value === 'Efectivo') {
      if (this.efectivoList.length === 1) {
        this.selfEmployed.efectivoId = this.efectivoList[0].uid;
      }
    }

    if (value === 'Póliza de crédito') {
      if (this.polizaCreditoList.length === 1) {
        this.selfEmployed.polizaCreditoId = this.polizaCreditoList[0].uid;
      }
    }

    if (value === 'Socio') {
      if (this.sociosList.length === 1) {
        this.selfEmployed.partnersId = this.sociosList[0].uid;
      }
    }

    if (value === 'Transferencia bancaria' || value === 'Cargo en cuenta' || value === 'Confirming' || value === 'Pagarés' ) {
      if (this.bankAccounts.length === 1) {
        this.selfEmployed.typePayBankAccount = this.bankAccounts[0].uid;
      }
    }

  }
  public trackByIndex(i: number) { return i; }

}
